import React, { useContext } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import PropTypes from 'prop-types';
import { isDesktop } from "react-device-detect";

//ads
import Caja3 from '../../ads/Caja3';

//context
import GalleryContext from '../../context/GalleryContext';

//components
import Button from '../common/Button';
import BackgroundImage from '../common/BackgroundImage';
import EmptySpace from '../common/EmptySpace';
import Video from './Video';

const GalleryItem = props => {

    const { idPhoto } = props;    
    const { dataGallery } = useContext(GalleryContext);    
    const { backgroudColorButton, colorButton, gallery, qryStrStart, queryStringText, subtitleColor, title, titleColor, urlAssets, urlEspecial, urlEspecialVideos } = dataGallery;  
    
    const galleryItem = gallery[idPhoto];
    const { id, itemSubtitle, itemTitle, text, video } = galleryItem;
    
    const firstItem = 1;
    const galleryKeys = Object.keys(gallery);
    const posCurrentItem = galleryKeys.indexOf(idPhoto);

    const findItemByPosition = pos => galleryKeys[pos];

    const prevItem = (id === firstItem) ? urlEspecial : `${urlEspecial}${qryStrStart}${queryStringText}=${findItemByPosition(posCurrentItem - 1)}`;
    const nextItem = (id !== galleryKeys.length) ? `${urlEspecial}${qryStrStart}${queryStringText}=${findItemByPosition(posCurrentItem + 1)}` : urlEspecial;

    const marginTopTitle = video ? 'mt-0' : 'mt-3 mt-md-5';

    return (
        <section className="position-relative">
            <BackgroundImage urlAssets={urlAssets} alt={title} />
            <section className="position-absolute start-50 translate-middle-x w-100 cont-layout container-titular">
                <article className="mx-auto px-3 px-md-0 gallery-item">
                    {
                        video 
                            ? <Video urlEspecialVideos={urlEspecialVideos} slug={idPhoto} />
                            : <LazyLoadImage
                                alt={itemTitle}
                                className="img-fluid"
                                effect="blur"
                                src={`${urlAssets}img/${idPhoto}.gif`}
                                wrapperClassName="w-100"
                            />
                    }                    
                    <h1 className= {`${marginTopTitle} mb-1 text-start title`} style={{ color: titleColor }}>{itemTitle}</h1>
                    <h2 className="mb-2 mb-md-4 text-start item-subtitle" style={{ color: subtitleColor }}>{itemSubtitle}</h2>
                    <div className="separator"></div>
                    <p className="my-3 my-md-5 mb-0 epigraph">{text}</p>
                </article>                
                <section className="d-flex justify-content-start mt-0 mt-md-3 mb-5 mx-auto px-3 px-md-0 gallery-item">
                    <section className="me-2">
                        <Button 
                            styles={{ backgroundColor: backgroudColorButton, color: colorButton }} 
                            text="anterior"
                            url={prevItem}
                        />
                    </section>
                    <section className="ms-2">
                        <Button 
                            styles={{ backgroundColor: backgroudColorButton, color: colorButton }} 
                            text="siguiente"
                            url={nextItem}
                        />
                    </section>
                </section>
                <section className="content-msgs">
                    {!isDesktop && <Caja3 />}        
                </section>  
                <EmptySpace />
            </section>      
        </section>
    )
}

export default GalleryItem

GalleryItem.propTypes = {
    idPhoto: PropTypes.string.isRequired,
}